<template>
    <div class="categories__row" v-if="model.Items.length == 3">
        <div class="categories__col">
            <a class="categories__map" :href="bigItem.Link.Url" :target="bigItem.Link.Target">
                <img :data-src="bigItem.Image" :alt="bigItem.ImageAlt">
                <div class="categories__place">{{model.CopyTitle}}</div>
            </a>
            <div class="categories__text" v-html="model.Copy"></div>
        </div>
        <div class="categories__col">
            <ul class="categories__group">
                <li v-for="i in smallItems">
                    <a :href="i.Link.Url" :target="i.Link.Target" v-if="i.Link != null">
                        <img :data-src="i.Image" :alt="i.ImageAlt">
                        <div class="categories__title">{{i.Link.Name}}</div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            model: Object
        },
        data() {
            return {
                selected: 0
            }
        },
        computed: {
            bigItem() {
                return this.model.Items[0]
            },
            smallItems() {
                return this.model.Items.slice(1)
            }
        },
        mounted() {
            window.lazyLoad.update()
        }
    }
</script>